import { print } from 'graphql';
import getAllRetailers from './allretailers.graphql';
import getAllStoreDetails from './allstoredetails.graphql';
import getContentPage from './contentpage.graphql';
import getContentListingPage from './clp.graphql';
import getDynamicForm from './dynamicform.graphql';
import getFrontPage from './frontpage.graphql';
import getHero from './hero.graphql';
import getInfoBlock from './infoblock.graphql';
import getStoreDetails from './storedetails.graphql';
import getStorePage from './storepage.graphql';
import getTextAndMedia from './textandmedia.graphql';
import getTextBlock from './textblock.graphql';

export default {
  getAllRetailers: print(getAllRetailers),
  getAllStoreDetails: print(getAllStoreDetails),
  getContentPage: print(getContentPage),
  getContentListingPage: print(getContentListingPage),
  getDynamicForm: print(getDynamicForm),
  getFrontPage: print(getFrontPage),
  getHero: print(getHero),
  getInfoBlock: print(getInfoBlock),
  getStoreDetails: print(getStoreDetails),
  getStorePage: print(getStorePage),
  getTextAndMedia: print(getTextAndMedia),
  getTextBlock: print(getTextBlock),
};
